import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import Urls, { queryStringifyUrl } from '../urls';

export default class SeriesUtils {
  static endUserAssignmentUrl(
    moduleAssignmentType,
    moduleAssignmentId,
    moduleId,
    trainingSeriesUserAssignmentId,
    parentAssignmentIds = null,
  ) {
    let url = '';
    switch (moduleAssignmentType) {
      case AssetPickerTypes.GUIDE: {
        url = moduleAssignmentId ? `/guide_assignments/${moduleAssignmentId}` : null;
        if (moduleAssignmentId) {
          url += `/path_assignment_id/${trainingSeriesUserAssignmentId}`;
        }
        break;
      }
      case AssetPickerTypes.RESOURCE:
        url = moduleAssignmentId ? `/resources/${moduleAssignmentId}` : null;
        break;
      case AssetPickerTypes.CHALLENGE:
        url = moduleAssignmentId ? `/challenge_assignments/${moduleAssignmentId}` : null;
        break;
      case AssetPickerTypes.CLASS:
        url = Urls.eventOverview(moduleId, trainingSeriesUserAssignmentId);
        break;
      case AssetPickerTypes.SCORM:
        url =
          moduleId && trainingSeriesUserAssignmentId
            ? `/scorm/${moduleId}?training_series_user_assignment_id=${trainingSeriesUserAssignmentId}`
            : null;
        break;
      case AssetPickerTypes.SERIES:
        url = moduleAssignmentId ? `/series_assignments/${moduleAssignmentId}` : null;
        break;
      case AssetPickerTypes.UDEMY:
      case AssetPickerTypes.LINKEDIN_LEARNING:
        url = moduleId && trainingSeriesUserAssignmentId ? `/content_provider_content/${moduleId}` : null;
        break;
      default:
        url = '';
    }

    if (url && parentAssignmentIds) {
      url = queryStringifyUrl(url, { parent_assignment_ids: parentAssignmentIds });
    }

    return url;
  }
}
